import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListQuotesComponent } from './components/list-quotes/list-quotes.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MainQuotesComponent } from './components/main-quotes/main-quotes.component';
import { QuoteDocumentComponent } from './components/quote-document/quote-document.component';
import { PreviewQuoteComponent } from './components/preview-quote/preview-quote.component';
import { QuoteRejectComponent } from './components/quote-reject/quote-reject.component';
import { DaysAgoOrLeftPipe } from 'src/app/config/days-ago-or-left';

@NgModule({
  declarations: [
    ListQuotesComponent,
    DaysAgoOrLeftPipe,
    MainQuotesComponent,
    QuoteDocumentComponent,
    PreviewQuoteComponent,
    QuoteRejectComponent,
  ],
  imports: [CommonModule, SharedModule],
  exports: [DaysAgoOrLeftPipe],
})
export class QuotesModule {}
